import { dashboardActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    schedule: {},
    scheduleAdmissions: {},
    unavailableBlocks: {},
    todaysSchedule: {},
    todaysScheduleAdmissions: {},
    outstandingNotes: {},
    openEvalPdf: false,
};

export const reducer = createReducer(initialState, {
    [dashboardActions.loadScheduleSuccess]: (state, action) => {
        state.schedule = action.payload.response.entities.schedule ? action.payload.response.entities.schedule : {};
        state.scheduleAdmissions = action.payload.response.entities.scheduleAdmissions ? action.payload.response.entities.scheduleAdmissions : {};
        state.unavailableBlocks = action.payload.response.entities.unavailableBlocks ? action.payload.response.entities.unavailableBlocks : {};
    },
    [dashboardActions.loadUserPreferencesSuccess]: (state, action) => {
        state.openEvalPdf = action.payload.response;
    },
    [dashboardActions.saveUserPreferencesSuccess]: (state, action) => {
        state.openEvalPdf = action.payload;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        state.schedule = action.payload.schedule.entities.schedule ? action.payload.schedule.entities.schedule : {};
        state.scheduleAdmissions = action.payload.schedule.entities.scheduleAdmissions ? action.payload.schedule.entities.scheduleAdmissions : {};
        state.unavailableBlocks = action.payload.schedule.entities.unavailableBlocks ? action.payload.schedule.entities.unavailableBlocks : {};
        state.outstandingNotes = action.payload.outstandingNotes.entities.outstandingNotes ? action.payload.outstandingNotes.entities.outstandingNotes : {};
    },
    [dashboardActions.loadTodaysScheduleSuccess]: (state, action) => {
        state.todaysSchedule = action.payload.response.entities.schedule ? action.payload.response.entities.schedule : {};
        state.todaysScheduleAdmissions = action.payload.response.entities.scheduleAdmissions ? action.payload.response.entities.scheduleAdmissions : {};
    },
    [dashboardActions.loadOutstandingNotesSuccess]: (state, action) => {
        state.outstandingNotes = action.payload.response.entities.outstandingNotes ? action.payload.response.entities.outstandingNotes : {};
    },
})